import React, { PureComponent } from 'react';
import { toastr } from 'react-redux-toastr';

import Header from '../../../components/Header';
import HeaderButton, {ButtonEndWrapper, PDFButton} from '../../../components/Header/ButtonsHeader/DefaultButton';
import { MainContainer, PageContainer, BaseColumn, StyledRow, StyledSpan } from '../../../components/shared/sharedStyles.styles';
import RequestsTable from './RequestsTableBuscarCobranca';
import SearchGroupBuscarCobranca from './SearchGroupBuscarCobranca';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter, setFinalDate, setStartDate, getRequests, changePage, setSelectFilter, resetSelectFilter } from './actions';

import { instance as axiosInstance } from '../../../services/axiosInstance';
import { BREADCRUMB_FINANCEIRO } from '../../../utils/breadcrumbFinanceiro';

class Requests extends PureComponent {
  
  state = {
    selectedOption: '',
    listData: [],
    idsChecked: [],
    inputFilter: '',
    selectedFilter: 'cobranca_id',
    requesting: false,
    startDate: '',
    endDate: '',
    pagination: {}
  }

  componentDidMount() {
    if (!this.props.login.user.usuario.master) {
      this.props.history.goBack();
    }
    this.getCobrancas()
  }

  getCobrancas = async () => {
    try {
      this.setState({requesting: true})
      let URL = `/api/cobrancas?`
      const inputFilter = this.state.inputFilter
      const startDate = this.state.startDate
      const endDate = this.state.endDate

      if(inputFilter) {
        if(this.state.selectedFilter === 'cobranca_id') {
          URL = `${URL}&cobranca=${inputFilter}`
        } else if(this.state.selectedFilter === 'solicitacao_id') {
          URL = `${URL}&solicitacao=${inputFilter}`
        } else if(this.state.selectedFilter === 'cliente') {
          URL = `${URL}&cliente_nome=${inputFilter}`
        }
      }

      if(startDate) {
        URL = `${URL}&start_date=${startDate}`
      }
      if(endDate) {
        URL = `${URL}&end_date=${endDate}`
      }

      if(this.state.pagination.current_page) {
        URL = `${URL}&page=${this.state.pagination.current_page}`
      }

      // if(true) {
      //   URL = `${URL}&perPage=${10}`
      // }

      const token = this.props.login.user.token.access_token

      const headers = {
        'Authorization': `Bearer ${token}`
      }

      const result = await axiosInstance.get(URL, {headers});
      if(result.status === 401) {
        this.props.history.push('/auth')
        return;
      } else if(result.status === 422 || result.status === 403) {
        toastr.warning('Aviso!', result.data.message);
        this.setState({listData: [], requesting: false, pagination: {current_page: 1, total: 1, last_page: 1, next_page_url: null}})
        return;
      }
      const response = result.data.data;
      this.setState({listData: [...response], requesting: false, pagination: {...result.data}})
      return response;
    } catch(err) {
      console.log('ERR:', err)
      this.setState({requesting: false})
      throw err
    }
  }

  putBaixarCobrancas = async () => {
    try {
      const URL = `/api/cobrancas/baixar`

      const token = this.props.login.user.token.access_token

      const headers = {
        'Authorization': `Bearer ${token}`
      }

      const data = {
        cobrancas: this.state.idsChecked
      }

      const result = await axiosInstance.put(URL, data, {headers});
      if(result.status === 401) {
        this.props.history.push('/auth')
        return;
      } else if(result.status === 422 || result.status === 403) {
        toastr.warning('Aviso!', result.data.message);
        return;
      }

      const response = result.data;
      toastr.success('Sucesso!', result.data.message);
      this.setState({idsChecked: []})
      console.log('productsx1ss', response)
      return response;
    } catch(err) {
      console.log('ERR:', err)
      throw err
    }
  }

  removeItemOnce = (arr, value) => {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  handleChangeCheck = (e) => {
    const id = Number(e.target.id)
    const checked = e.target.checked
    console.log('target1', id)
    console.log('target2', checked)
    if(checked) {
      this.setState({idsChecked: [...this.state.idsChecked, id]})
      return;
    }
    this.setState({idsChecked: [...this.removeItemOnce(this.state.idsChecked, id)]})
  }

  addRequest = () => {
    const { history } = this.props;
    history.push('/intranet/operacional/solicitacao/adicionar');
  }

  handleButtonBaixar = async () => {
    console.log('BAIXOU')
    await this.putBaixarCobrancas()
    this.getCobrancas()
  }

  onFilter = (text) => {
    const { setFilter, getRequests, changePage } = this.props;
    setFilter(text);
    this.setState({selected: true, inputFilter: text})
  }

  lastday = (y, m) => {
    // Create a new Date object representing the last day of the specified month
    // By passing m + 1 as the month parameter and 0 as the day parameter, it represents the last day of the specified month
    return new Date(y, m + 1, 0).getDate();
  }

  onSetStartDate = (date) => {
    let dateFormatted = date.replaceAll('_', '')
    if(dateFormatted.length === 7) {
      dateFormatted = dateFormatted.split('/')
      this.setState({startDate: `${dateFormatted[1]}-${dateFormatted[0]}-${this.lastday(dateFormatted[1], Number(dateFormatted[0])-1)}`})
    }
    if(!date) {
      this.setState({startDate: ''})
    }
    this.props.setStartDate(date)
  }

  onSetEndDate = (date) => {
    let dateFormatted = date.replaceAll('_', '')
    if(dateFormatted.length === 7) {
      dateFormatted = dateFormatted.split('/')
      this.setState({endDate: `${dateFormatted[1]}-${dateFormatted[0]}-${this.lastday(dateFormatted[1], Number(dateFormatted[0])-1)}`})
    }
    if(!date) {
      this.setState({endDate: ''})
    }
    this.props.setFinalDate(date)
  }

  onFilterDate = () => {
    const {params: {id}} = this.props.match
    this.props.changePage(1)
    // this.props.getRequests(id)
    this.getCobrancas()
  }

  onChangeSelectFilter = (e) => {
    const value = e.target.value
    console.log('vvvvv', value)
    this.setState({selectedOption: value, selectedFilter: value})
    this.props.setSelectFilter(value)
  }

  onResetSelectFilter = () => {
    this.setState({selectedOption: ''})
    this.props.resetSelectFilter()
  }

  onChangePage = (page) => {
    this.setState({pagination: {...this.state.pagination, current_page: page}}, () => {
      this.getCobrancas()
    })
  }

  render() {
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 800px)').matches;
    console.log('cheks:', this.state)
    console.log('cheks props:', this.props)
    let pagination = {
      ...this.state.pagination,
      totalCount: this.state.pagination.total,
      lastPage: this.state.pagination.last_page,
      currentPage: this.state.pagination.current_page,
      perPage: parseInt(this.state.pagination.per_page, 10),
    }
    delete pagination.data
    return (
      <PageContainer>
        <Header
          breadcrumb={BREADCRUMB_FINANCEIRO}
          title="Segunda via de boleto"
          actualLink="Segunda via de boleto"
        />
        <MainContainer style={{ paddingTop: 0, marginTop: isMobile ? 42 : 0 }}>
          <StyledRow justify="flex-start" align="flex-start" customStyle="height: auto; margin-top: 0; margin-bottom: 8px;">
            <SearchGroupBuscarCobranca 
              endDate={this.onSetEndDate} 
              startDate={this.onSetStartDate} 
              setFilter={this.onFilter}
              filterDate={this.onFilterDate}
              changeSelectFilter={this.onChangeSelectFilter}
              resetSelectFilter={this.onResetSelectFilter}
              selectedOption={this.state.selectedOption}
              showSelectFilter={true}
            />
          </StyledRow>
          <RequestsTable listData={this.state.listData} handleChangeCheck={this.handleChangeCheck} requesting={this.state.requesting} pagination={pagination} onChangePage={this.onChangePage} />
        </MainContainer>
      </PageContainer>
    );
  }
}

function MapStateToProps (state){
  return {
    date: state.requestsTable.pagination.date,
    login: state.login,
  }
}

const MapDispatchToProps = (dispatch) => bindActionCreators({setFilter, setFinalDate, setStartDate, getRequests, changePage, setSelectFilter, resetSelectFilter}, dispatch)

export default connect(MapStateToProps, MapDispatchToProps)(Requests)